 
<template>
  <div class="custom-sythree">
    <div class="info-content">
      <div class="left">
        <p>{{ data.text }}</p>
        <!-- 人数需要socket实时推送 -->
        <p v-if="curOnlineNum">{{curOnlineNum}}人正在参与通话…</p>
        <p v-else>还未有人参与通话…</p>
      </div>
      <div class="right" @click="joinVideo">
        <span class="vedio-icon"></span>
        <span class="text-sign">点击进入</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    curOnlineNum: {
      type:Number,
      default: 0,
    },
    hideClick:{
      type:Boolean,
      default: false,
    }
  },
  methods: { 
    joinVideo() { 
      if(this.hideClick){
        return
      }
      this.$emit("joinVideo", this.data);
    }
  }
};
</script>

<style scoped lang="less">
.custom-sythree {
  width: 350px;
  cursor: pointer;
  background: #ffffff;
  box-shadow: 0px 4px 8px 0px rgba(204, 204, 204, 0.2);
  border-radius: 6px;
  border: 1px solid #f5f5f5;
  .info-content {
    padding: 15px 20px;
    font-size: 12px;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
    .right {
      display: flex;
      align-items: center;
      span { 
        color: #1A7BFC; 
        font-weight: 500;
      }
    }
    .left {
      line-height: 24px;
      p {
        margin: 4px 0;
      }
    }
    .vedio-icon {
      display: flex;
      width: 20px;
      height: 20px;
      background: url(../../static/IMInput/vedio_icon.png) no-repeat;
      background-size: contain;
      margin-right: 8px;
    }
    span {
      font-size: 12px;
      color: #333333;
    }
  }
}
</style>